import { render, staticRenderFns } from "./BindsCard.vue?vue&type=template&id=169615b6&scoped=true&"
import script from "./BindsCard.vue?vue&type=script&lang=js&"
export * from "./BindsCard.vue?vue&type=script&lang=js&"
import style0 from "./BindsCard.vue?vue&type=style&index=0&id=169615b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169615b6",
  null
  
)

export default component.exports